<content-panel #panel [itemsCount]="totalCount" [hidden]="impacterId"
               [loading]="loading" >
  <ng-template contentList [items]="impacters" [headerTemplate]="headerTemplate" [itemTemplate]="itemTemplate">
  </ng-template>
  <ng-template contentList [items]="suggestions" backgroundColor="transparent"
               [headerTemplate]="headerSuggestionsTemplate" [itemTemplate]="itemTemplate">
  </ng-template>
  <ng-template contentFooter>
    @if (nbPages > 1) {
      <app-pagination [nbPages]="nbPages" [stats]="dataUpdated" [inImpacterView]="!!impacterId"></app-pagination>
    }
  </ng-template>
  <ng-template contentLoading>
    <div class="content-loading">
      <ex-overlay-loader direction="column" color="secondary" [text]="'search.loading' | translate"></ex-overlay-loader>
    </div>
  </ng-template>
  <ng-template contentEmpty>
    <div class="content-state">
      <mat-icon svgIcon="close-circle-fill" size="120"></mat-icon>
      <div class="state-title">{{'content.no-result-message' | translate}}</div>
      <div class="state-subtitle">
        {{'content.indicative-no-result-message' | translate}}
      </div>
    </div>
  </ng-template>
</content-panel>
<section [hidden]="!impacterId">
  <router-outlet></router-outlet>
</section>


<ng-template #headerTemplate>
  <div class="results-header">
    <div class="flex-1">
      <div class="results-title">
        {{ (totalCount == 10000 ? 'search.more-than' : "") | translate }}
        {{ totalCount?.toLocaleString() }}
        {{ (totalCount && totalCount > 1 ? 'search.results' : 'search.result') | translate }}
      </div>
      <div class="results-subtitle">
        {{ 'search.impacter-results' | translate }}
      </div>
    </div>
  </div>
</ng-template>
<ng-template #headerSuggestionsTemplate>
  <div class="results-header">
    <div class="flex-1">
      <div class="results-title">
        {{ suggestionCount.toLocaleString() }}
        {{ (suggestionCount && suggestionCount > 1 ? 'search.suggestion-results' : 'search.suggestion-result')
        | translate }}
      </div>
      <div class="results-subtitle">
        {{ (suggestionCount && suggestionCount > 1 ? 'search.suggestion-sub-results' : 'search.suggestion-sub-result')
        | translate }}
      </div>
    </div>
  </div>
</ng-template>
<ng-template #itemTemplate let-item>
  <app-impacter-card
    [impacterId]="item.id"
    [name]="item.name"
    [positions]="item.positions"
    [byFilter]="item.byFilter"
  >
  </app-impacter-card>
</ng-template>

